<template>
  <b-sidebar
    class="sidebar-container-responsive preferences-sidebar"
    right
    id=""
    :visible="visible"
    bg-variant="white"
    backdrop
    shadow
    no-close-on-backdrop
    no-close-on-esc
    no-header-close
  >
    <aside class="preferences-aside">
      <img
        class="close-icon"
        src="@/assets/icons/close_sidebar.svg"
        alt
        @click="closePreferencesSidebar"
      />
      <h2 class="font-md">
        {{
          selectedCustomer && selectedCustomer.text ? selectedCustomer.text : ""
        }}
        Preferences
      </h2>
      <h3 class="font-lg" v-if="sidebarPreferences.length === 0">
        No Preferences to show
      </h3>
      <h3 class="font-sm" v-else>Preferences</h3>
      <div
        class="preference-box-wrapper"
        v-for="preference in sidebarPreferences"
        :key="preference.id"
      >
        <div class="preference-box">
          <div class="preference-box-header">
            <div class="preference-title">{{ preference.title }}</div>
          </div>
          <div class="preference-content-wrapper">
            <div class="preference-content">
              <vue-carousel
                :controls="preference.descriptions.length > 1"
                :autoplay="false"
                direction="right"
                :data="preference.descriptions"
              ></vue-carousel>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom-close-wrapper">
        <img
          class=""
          src="@/assets/icons/close_sidebar.svg"
          alt
          @click="closePreferencesSidebar"
        />
      </div>
    </aside>
  </b-sidebar>
</template>

<script>
export default {
  name: "TaskSidebarComponent",
  props: ["sidebarPreferences", "visible", "selectedCustomer"],
  methods: {
    closePreferencesSidebar() {
      this.$emit("closeSidebar");
    }
  }
};
</script>

<style scoped lang="scss">
@import "~@/scss/variables/colors.scss";
.breadcrumb-container-left {
  left: 0;
}
.customer-details {
  right: 2%;
  overflow-wrap: break-word;
}
.preferences-card-wrapper {
  margin-bottom: 5rem;
  padding-right: 1.5rem;
}
.preferences-categories-card {
  border-radius: 10px;
}
.sidebar-preferences-wrapper {
  margin-bottom: 10rem;
}
.add-attachment-top {
  top: 0.8rem;
  // border: 1px solid #dcebf4 !important;
}
.tasks-attachment-card {
  width: inherit;
  border: 1px solid #dcebf4 !important;
  height: 4rem;
  padding-left: 1.2rem;
  padding-right: 1.2rem;
}
.high-priority-text {
  margin: 2px;
}
.tasks-form-card {
  height: 4rem;
}
.comment-card-body {
  width: 30rem;
}
.tasks-vertical-divider {
  border-left: 1px solid $primary-lighter;
  top: 3rem;
}
.add-comment-input-box {
  height: 4rem;
  min-height: 4.4rem;
}
.remove-option-icon {
  right: 0.5rem;
}
.start-timer-btn {
  padding: 1rem 2rem !important;
}
.start-timer-btn p,
.timer-running-container p {
  // line-height: 1.8rem !important;
  color: #784f89;
  top: 1.3rem;
}

.checkbox-title-container {
  z-index: 0;
  top: 0.2rem;
}

.attachment-name {
  font-size: 1.5rem !important;
}

.show-timer p {
  top: 1.2rem;
}
.attachment-delete-btn,
.checklist-delete-btn {
}
.checklist-options-container {
  // height: 3rem;
  margin-bottom: 2.4rem;
}

.tasks-dropdown-divider {
  margin-top: 2.5rem;
}

.tasks-right-container {
  position: fixed;
  right: 0;
  z-index: 2;
  display: flex;
  // max-width: 21.66%;
  // flex: 0 0 21.66%;
  // width: 21.6%;
  top: 9rem;
  background: #fff;
  height: 100vh;
  overflow-y: auto;
}
.input-icon-container {
  right: 1rem;
  top: 1.2rem;
}
.box-container {
  height: 10rem;
  border-radius: 6px;
  // padding: 2rem;
  width: 15rem;
}

.show-timer-container {
  margin-top: -6rem;
}

.box-container a {
  opacity: 0.3;
}
.box-container.thumbnail-wrapper {
  > img {
    width: 100%;
    height: 100%;
    cursor: pointer;
  }
}

.carousel-outer-container p {
  margin-top: 1rem;
}
.tasks-preferences {
  z-index: 100000;
  width: inherit;
}
.timer-resume {
  right: -1.5px;
  cursor: pointer;
}
.tasks-textarea {
  min-height: 17rem !important;
}
.status-field {
  margin-top: 40px;
}
.checklist-title-input {
  width: 80%;
  z-index: 5;
}
.checklist-title {
  z-index: 2;
  cursor: pointer;
}
.checklist-option-input-wrapper {
  flex: 1;
}
button.btn.close-btn {
  right: -2.5rem;
  top: -2rem;
  background: none;
}
.save-button-row {
  padding-left: 30px;
  .save-button {
    background: $button-secondary;
  }
}
@media screen and (max-width: 991px) {
  .add-task-container {
    left: 0;
    width: 100%;
  }
  .add-task-container,
  .view-task-container {
    top: 18rem;
  }
}
@media screen and (max-width: 599px) {
  .add-task-container {
    height: 100vh;
  }
}
</style>
